<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/contact/form">お問い合わせフォーム</router-link></li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <div class="contact__title">
        <div class="container">
          <h2>お問い合わせ</h2>
          <ul class="contact__process step1">
            <li class="active">
              <span>1.入力</span>
            </li>
            <li>
              <span>2.確認</span>
            </li>
            <li>
              <span>3.完了</span>
            </li>
          </ul>
          <p>HARUMI FLAGの街における「エリアマネジメント活動」や「イベント」に関するお問い合わせを受け付けております。<br>
            以下のフォームに必要事項をご入力のうえ、内容を確認して確認画面へお進みください。<br>
            ＊マンションに関することはマンションポータルの「お問い合わせ」、店舗に関することは「直接店舗」へお問い合わせください。<br>
            ＊お問い合わせ内容によっては、回答いたしかねる場合がございますので、ご了承ください。</p>
        </div>
      </div>
      <div class="contact__content">
        <div class="container">
          <form class="form" @submit="submitConfirm">
            <div class="form__row">
              <div class="form__title">
                <label>氏名<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <div class="form__content__child">
                  <div class="form__title2">
                    <label>姓</label>
                  </div>
                  <input
                    class="i_name"
                    type="text"
                    name="name"
                    v-model="contact_meta.name"
                    maxlength="60"
                  />

                  <div class="form__title2">
                    <label class="label__two">名</label>
                  </div>
                  <input
                    class="i_name"
                    type="text"
                    name="first_name"
                    v-model="contact_meta.first_name"
                    maxlength="60"
                  />
                </div>
               
                <div class="custom-err">
                  <div class="left-err">
                    <p v-if="!checkName" class="form__error">
                      お名前を入力してください。
                    </p>
                    <p v-if="checkName && !checkValidName" class="form__error">
                      形式が正しくありません。
                    </p>
                  </div>
                  <div class="right-err">
                    <p v-if="!checkFirstName" class="form__error">
                      お名前を入力してください。
                    </p>
                    <p v-if="checkFirstName && !checkValidFirstName" class="form__error">
                      形式が正しくありません。
                    </p>
                  </div>
                </div>

              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>法人団体名</label>
              </div>
              <div class="form__content">
                <input type="text" name="company" v-model="contact_meta.company" />
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>メールアドレス<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <input
                  type="text"
                  name="email_address"
                  v-model="contact_meta.email_address"
                />
                <p v-if="!checkMailAddress" class="form__error">
                  メールアドレスを入力してください。
                </p>
                <p v-if="checkMailAddress && !checkValidMailAddress" class="form__error">
                  形式が正しくありません。
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>メールアドレス(確認用)<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <input
                  type="text"
                  name="email_address_confirm"
                  v-model="email_address_confirm"
                />
                <p v-if="!checkMailAddressConfirm" class="form__error">
                  メールアドレスを入力してください。
                </p>
                <p v-if="checkMailAddressConfirm && !checkValidMailAddressConfirm" class="form__error">
                  形式が正しくありません。
                </p>
                <p v-if="checkMailAddressConfirm && checkValidMailAddressConfirm && checkMailAddress !== checkMailAddressConfirm" class="form__error">
                  アドレスが一致しません。
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>電話番号<span class="note">＊ハイフンなしで入力してください</span></label>
              </div>
              <div class="form__content">
                <input
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="text"
                  name="phone_number"
                  v-model="contact_meta.phone_number"
                  maxlength="13"
                  placeholder="ハイフンなしで入力してください"
                />
                <p v-if="!checkPhone" class="form__error">
                  形式が正しくありません。
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>お問い合わせの種類<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <select class="s_select" name="selected" v-model="contact_meta.inquiry_detail_type">
                  <option value="" disabled selected hidden>選択してください</option>
                  <option>エリアマネジメント活動について</option>
                  <option>イベントについて</option>
                </select>
                <div v-if="checkSelected" class="bg__select"><i class="arrow down"></i></div>
                <div v-if="!checkSelected" class="bg__select err--select"><i class="arrow down"></i></div>
                <p v-if="!checkSelected" class="form__error">
                  お問い合わせの種類を選択してください
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title2">
                <div class="lable__title">
                  <label>返信希望<span class="required">必須</span></label>
                </div>
                <div class="radio__content">
                  <div class="radio__content__one">
                    <input type="radio" id="希望する" name="希望する" value="希望する" v-model="contact_meta.reply" />
                    <label for="希望する">希望する</label>
                  </div>
                  <div class="radio__content__two">
                    <input type="radio" id="希望しない" name="希望しない" value="希望しない" v-model="contact_meta.reply" />
                    <label for="希望しない">希望しない</label>
                  </div>
                </div>
              </div>
              <div class="form__content">
                <p v-if="!checkRadio" class="form__error">
                  返信希望を選択してください
                </p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__title">
                <label>お問い合わせ内容<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <textarea
                  name="inquiry_detail"
                  v-model="contact_meta.inquiry_detail"
                  rows="5"
                  cols="50"
                ></textarea>
                <p v-if="!checkInquiry" class="form__error">
                  お問い合わせ内容を入力してください。
                </p>
                <p v-if="checkInquiry && !checkValidInquiry" class="form__error">
                  形式が正しくありません。
                </p>
              </div>
            </div>
            <div class="text__link"><a href="/privacypolicy" target="_blank">個人情報保護方針</a>をご確認ください。</div>
            <div class="form__button">
              <button class="btn icon--white" type="submit">個人情報保護方針に同意する</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { RouterLink } from "vue-router";
import { metaData } from '@/utils/helper';

export default {
  name: "ContactForm",
  props: ['dataProp'],
  data() {
    return {
      contact_meta: {
        first_name: "",
        name: "",
        company: "",
        email_address: "",
        phone_number: "",
        inquiry_detail_type: "",
        reply: "",
        inquiry_detail: "",
      },
      email_address_confirm: "",
      checkFirstName: true,
      checkValidFirstName: true,
      checkName: true,
      checkValidName: true,
      checkMailAddress: true,
      checkValidMailAddress: true,
      checkMailAddressConfirm: true,
      checkValidMailAddressConfirm: true,
      checkPhone: true,
      checkSelected: true,
      checkRadio: true,
      checkInquiry: true,
      checkValidInquiry: true
    };
  },
  mounted() {
    if(this.$props.dataProp != undefined) {
      this.contact_meta.first_name = this.$props.dataProp.contact_meta.first_name,
      this.contact_meta.name = this.$props.dataProp.contact_meta.name,
      this.contact_meta.company = this.$props.dataProp.contact_meta.company
      this.contact_meta.email_address = this.$props.dataProp.contact_meta.email_address
      this.email_address_confirm = this.$props.dataProp.contact_meta.email_address,
      this.contact_meta.phone_number = this.$props.dataProp.contact_meta.phone_number,
      this.contact_meta.inquiry_detail_type = this.$props.dataProp.contact_meta.inquiry_detail_type,
      this.contact_meta.reply = this.$props.dataProp.contact_meta.reply,
      this.contact_meta.inquiry_detail = this.$props.dataProp.contact_meta.inquiry_detail
    }
  },
  methods: {
    validateName(name) {
      if (/^[a-zA-Zぁ-んァ-ン一-龥]+$/.test(name)) {
        return true
      }
      return false
    }, 
    validateEmail(mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true
      }
      return false
    }, 
    validatePhone(phone) {
      if (phone === '' || /^\d+$/.test(phone)) {
        return true
      }
      return false
    }, 
    validateInquiry(inquiry) {
      if (/^\d+$/.test(inquiry)) {
        return false
      }
      return true
    }, 
    submitConfirm(event) {
      event.preventDefault();
      this.checkFirstName = this.contact_meta.first_name || false;
      this.checkValidFirstName = this.validateName(this.contact_meta.first_name) || false;
      this.checkName = this.contact_meta.name || false;
      this.checkValidName = this.validateName(this.contact_meta.name) || false;
      this.checkMailAddress = this.contact_meta.email_address || false;
      this.checkValidMailAddress = this.validateEmail(this.contact_meta.email_address) || false;
      this.checkMailAddressConfirm = this.email_address_confirm || false;
      this.checkValidMailAddressConfirm = this.validateEmail(this.email_address_confirm) || false;
      this.checkPhone = this.validatePhone(this.contact_meta.phone_number) || false;
      this.checkSelected = this.contact_meta.inquiry_detail_type || false;
      this.checkRadio = this.contact_meta.reply || false;
      this.checkInquiry = this.contact_meta.inquiry_detail || false;
      this.checkValidInquiry = this.validateInquiry(this.contact_meta.inquiry_detail) || false;
      if(
        this.checkFirstName &&
        this.checkValidFirstName &&
        this.checkName &&
        this.checkValidName &&
        this.checkMailAddress &&
        this.checkValidMailAddress &&
        this.checkMailAddressConfirm &&
        this.checkValidMailAddressConfirm &&
        this.checkPhone &&
        this.checkSelected &&
        this.checkRadio &&
        this.checkInquiry &&
        this.checkValidInquiry &&
        ( this.checkMailAddress === this.checkMailAddressConfirm )
      ){
        const data = {
          title: 'Webからのお問い合わせ',
          content: '',
          status: 'not_compatible',
          contact_meta: {
            first_name: this.contact_meta.first_name,
            name: this.contact_meta.name,
            company: this.contact_meta.company,
            email_address: this.contact_meta.email_address,
            // email_address_confirm: this.email_address_confirm,
            phone_number: this.contact_meta.phone_number,
            inquiry_detail_type: this.contact_meta.inquiry_detail_type,
            reply: this.contact_meta.reply,
            inquiry_detail: this.contact_meta.inquiry_detail
          }
        };
        this.$router.push({ name: "ContactFormConfirm", params: { data } });
      }
    }
  },
  created() {
    metaData(
      `お問い合わせ | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのお問い合わせについてのご案内ページです。',
      'HARUMIFLAGタウンポータル',
      'article'
    )
  }
};
</script>